import { Box, Title, Group } from '@mantine/core';

interface HeaderProps {
  title: string;
  titleSize?: 1 | 2 | 3 | 4 | 5 | 6;
  description?: string;
  actions?: React.ReactNode;
}

export const Header = ({
  title,
  titleSize = 2,
  description,
  actions,
}: HeaderProps) => {
  return (
    <Box mb="xl">
      <Group justify="space-between" align="start">
        <Box>
          <Title 
            order={titleSize} 
            style={{ 
              fontFamily: 'Montserrat, sans-serif',
              color: '#228be6',
              fontWeight: 600,
            }}
          >
            {title}
          </Title>
          {description && (
            <Box fz="sm" c="dimmed" mt="xs" style={{ fontWeight: 500 }}>
              {description}
            </Box>
          )}
        </Box>
        {actions && <Box>{actions}</Box>}
      </Group>
    </Box>
  );
};
